<template>
  <div class="animated fadeIn">

    <!-- First Row -->
    <div class="row">
      <div class="col">
        <h4><i class="fa fa-snowflake-o"></i><span class="ml-1">Status: {{ reward_data.status }}</span></h4>
      </div>
      <div class="col">
        <h4><i class="fa fa-snowflake-o"></i><span class="ml-1">Type: {{ reward_data.data_or_recharge }}</span></h4>
      </div>
      <div class="col">
        <h4><i class="fa fa-snowflake-o"></i><span class="ml-1">Phone: {{ reward_data.phone }}</span></h4>
      </div>
    </div>
    <!-- End First Row -->

    <!-- Second Row -->
    <div class="row">

      <!-- Left side -->
      <div class="col-6 table-responsive">

        <!-- table for data -->
        <div v-if="reward_data.data_or_recharge=='DATA'">
          <table class="table">
          <thead class="thead-dark">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Property</th>
            <th scope="col">Value</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <th scope="row">1</th>
            <td>data_success</td>
            <td>{{ reward_data.data_success }}</td>
          </tr>
          <tr>
            <th scope="row">2</th>
            <td>data_message</td>
            <td>{{ reward_data.data_message }}</td>
          </tr>
          <tr>
            <th scope="row">3</th>
            <td>data_error_code</td>
            <td>{{ reward_data.data_error_code }}</td>
          </tr>
          </tbody>
        </table>
        </div>
        <!-- End table for data -->

        <!-- table for recharge -->
        <div v-if="reward_data.data_or_recharge=='RECHARGE'">
          <table class="table">
            <thead class="thead-dark">
            <tr>
              <th scope="col">#</th>
              <th scope="col">Property</th>
              <th scope="col">Value</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th scope="row">1</th>
              <td>recharge_status</td>
              <td>{{ reward_data.recharge_status }}</td>
            </tr>
            <tr>
              <th scope="row">2</th>
              <td>recharge_message</td>
              <td>{{ reward_data.recharge_message }}</td>
            </tr>
            <tr>
              <th scope="row">3</th>
              <td>recharge_trans_id</td>
              <td>{{ reward_data.recharge_trans_id }}</td>
            </tr>
            <tr>
              <th scope="row">3</th>
              <td>recharge_msisdn</td>
              <td>{{ reward_data.recharge_msisdn }}</td>
            </tr>
            <tr>
              <th scope="row">3</th>
              <td>recharge_con_type</td>
              <td>{{ reward_data.recharge_con_type }}</td>
            </tr>
            <tr>
              <th scope="row">3</th>
              <td>recharge_operator</td>
              <td>{{ reward_data.recharge_operator }}</td>
            </tr>
            <tr>
              <th scope="row">3</th>
              <td>recharge_clientTrxId</td>
              <td>{{ reward_data.recharge_clientTrxId }}</td>
            </tr>

            </tbody>
          </table>
        </div>
        <!-- End table for recharge -->

      </div>

      <!-- Right side -->
      <div class="cardheading">
        <h4><i class="fa  fa-paper-plane"></i><span class="ml-1">Send Reward</span></h4>
        <!-- decision of whether to send data/recharge manually -->
        <div v-if="reward_data.status == 'SUCCEED' ">
          <div class="alert alert-warning" role="alert">
            This user has been awarded successfully in this instance.
          </div>
        </div>
        <!-- View to send data/ recharge -->
        <div v-else-if="already_send == 'false'">

          <CRow class="mt-12">
            <CCol sm="12">
              <CSelect
                  :options="['Select Type', 'Data', 'Recharge']"
                  size="lg"
                  :value.sync="type"

              />
            </CCol>

            <CCol v-if="type == 'Recharge'" sm="6">
              <CSelect
                  :options="['Select Operator', 'GP', 'BL', 'RB', 'AT', 'TT', 'GP ST']"
                  size="lg"
                  :value.sync="operator"

              />
            </CCol>

          </CRow>

          <div class="alert alert-warning" role="alert">
            the type is {{type}}
          </div>

          <div class="alert alert-warning" role="alert">
            the operator is {{operator}}
          </div>

          <button v-on:click="sendRewardApi" type="button" class="btn btn-square btn-dark">Send Reward</button>

<!--          <button v-on:change="send_status" type="button" class="btn btn-square btn-dark">{{ send_status }}</button>-->

        </div>
        <div v-else>
          <div class="alert alert-warning" role="alert">
            This user has been awarded in another instance.
          </div>
        </div>
      </div>
    </div>
    <!-- End Second Row -->

    <!-- Third Row -->
    <div class="row">
      <div class="col-6 table-responsive">
        <!-- Common data -->
        <table class="table">
          <thead class="thead-dark">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Property</th>
            <th scope="col">Value</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <th scope="row">1</th>
            <td>exception_code</td>
            <td>{{ reward_data.exception_code }}</td>
          </tr>
          <tr>
            <th scope="row">2</th>
            <td>exception_message</td>
            <td>{{ reward_data.exception_message }}</td>
          </tr>
          <tr>
            <th scope="row">3</th>
            <td>created_at</td>
            <td>{{ reward_data.created_at }}</td>
          </tr>
          <tr>
            <th scope="row">3</th>
            <td>updated_at</td>
            <td>{{ reward_data.updated_at }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- End Third Row -->



  </div>
</template>

<script>
import axios from "axios";
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;

export default {
  name: "SendGratification",

  data() {
    return {
      type: "",
      operator: "",
      reward_data: [],
      already_send: "",
      payload: [],
      send_status: "",
      date: new Date(),
      options: {
        pagination: { nav: "fixed" },
        filterByColumn: true,
        dateColumns: ["created_at"],
        //dateFormat: 'DD-MM-YYYY',
        toMomentFormat: true,
        sortIcon: {
          base: "fa fa-sort",
          up: "fa fa-sort-up",
          down: "fa fa-sort-down",
          is: "fa fa-sort",
        },
      },
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const id = this.$route.params.id;
      this.balance = id;

      axios.get(`${ADMIN_URL}/recharge-data-single/${id}`)
          .then(response => {

            if(response.data.success == true){
              this.reward_data = response.data.row;
              this.alreadyRewarded();
            }


          }).catch(error => {
        //console.log('Error. .. .', error.response);
        const errResponse = error.response;
        if (errResponse.status === 404) {
          this.user_notfound = true;
        }
      })

    },
    alreadyRewarded(){
      const phone=this.reward_data.phone;
      console.log('alreadyRewarded url ', `${ADMIN_URL}/recharge-data-taken-reward/${phone}`);
      axios.get(`${ADMIN_URL}/recharge-data-taken-reward/${phone}`)
          .then(response => {
            //console.log('Response  ', response.data);
            this.already_send=response.data.already_rewarded;

          }).catch(error => {
        //console.log('Error. .. .', error.response);
        const errResponse = error.response;
        if (errResponse.status === 404) {
          this.user_notfound = true;
        }
      })

    },
    sendRewardApi(){
      const payload = {
        type: this.type,
        operator: this.operator,
        user_id: this.reward_data.user_id,
        phone: this.reward_data.phone
      };

      axios.post(`${ADMIN_URL}/recharge-data-send-reward/`, payload)
          .then(response => {
            console.log('Response send reward  ', response.data);
            if(response.data == 'SUCCEED'){
              this.$swal("Result", response.data, "success");
            }else{
              this.$swal("Result", response.data, "warning");
            }


          }).catch(error => {
        //console.log('Error. .. .', error.response);
        const errResponse = error.response;
        if (errResponse.status === 404) {
          this.user_notfound = true;
          console.log('Response send reward fail ', response.data);
        }
      })
    },


  }
}
</script>

<style scoped>

</style>
